export const tagnameFilter = () => {
	return (name) => {
		if (!name) {
			return;
		}

		return name.substr(0, 2).replace(/[\.\-\s]/g, '');
	};
};
